import { gsap } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let stage1, stage2, stage3, stageEnd;

// Hover animation for "Co" in slogan
function initSloganHover() {

	const slogan = document.querySelector('.sloganWords');
	if (!slogan) return;

	const co = slogan.querySelector('.co');
	const mainText = slogan.querySelector('.mainText');

	// kill previous animations if any
	gsap.killTweensOf([co, mainText]);

	const coWidth = co.offsetWidth;

	// RESET STATE
	gsap.set(co, { clearProps:"all" });
	gsap.set(mainText, { clearProps:"all" });

	// initial state
	gsap.set(co, {
		xPercent: -100,
		autoAlpha: 0
	});

	gsap.set(mainText, {
		x: -(coWidth / 2)
	});

	// reveal slogan AFTER layout is ready
	gsap.fromTo(
		slogan,
		{
			autoAlpha: 0,
			y: 100
		},
		{
			autoAlpha: 1,
			y: 0,
			duration: 0.6,
			ease: "power2.out"
		}
	);

	const tlCo = gsap.timeline({ paused: true });

	tlCo
	.to(co, {
		xPercent: 0,
		autoAlpha: 1,
		duration: 0.45,
		ease: "power2.out"
	}, 0)

	.to(mainText, {
		x: 0,
		duration: 0.45,
		ease: "power2.out"
	}, 0);

	const arrow = slogan.querySelector(".arrow");
  	const arrowAnim = gsap.to(arrow, {
		y: 10,
		duration: 1.4,
		ease: "sine.inOut",
		repeat: -1,
		yoyo: true
	});

	slogan.addEventListener("mouseenter", () => {
		arrowAnim.pause();
		tlCo.play();
	});

	slogan.addEventListener("mouseleave", () => {
		arrowAnim.resume();
		tlCo.reverse();
	});
}

// Scroll to element and play timeline
function scrollToTriggerOffset(selector, vh = 50, duration = 3) {
	const el = document.querySelector(selector);
	if (!el) return;
  
	const offset = window.innerHeight * (vh / 100);
	const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
	gsap.to(window, {
	  scrollTo: y,
	  duration: duration,
	  ease: "power2.out"
	});
}

export function setupApproachAnimations() {
	console.log("✅✅setupApproachAnimations CALLED");

	// Initialize the slogan hover animation
	const slogan = document.querySelector('.sloganWords');
    if (slogan) {
		initSloganHover();
	}

	const mm = gsap.matchMedia();

	document.querySelector("#btnStage1").addEventListener("click", () => {
		scrollToTriggerOffset(".stage-1", -50, 2); // 50vh offset, duration 1s
		console.log("Button clicked, scrolling to Stage 1");
	});
	document.querySelector("#btnStage2").addEventListener("click", () => {
		scrollToTriggerOffset(".stage-2", -50, 2);
	});
	document.querySelector("#btnStage3").addEventListener("click", () => {
		scrollToTriggerOffset(".stage-3", -70, 2);
	});
	document.querySelector("#btnStage4").addEventListener("click", () => {
		scrollToTriggerOffset(".stageEnd", -50, 2);
	});

	// Helper: Get current circle size & separations
	function getMetrics() {
		const size = window.matchMedia("(max-width:768px)").matches ? 300 : 400;
		const sepX = size * 0.35;
		const sepY = size * 0.35;
		// const scrollDuration = window.matchMedia("(max-width:768px)").matches ? 500 : 2000;
		const scrollEndValue = window.matchMedia("(max-width:576px)").matches ? "bottom bottom" : "+=500";
		const scrollStartValueSlogan = window.matchMedia("(max-width:576px)").matches ? "top 55%" : "top 75%";
		const scrollStartValueStage1 = window.matchMedia("(max-width:576px)").matches ? "top 55%" : "top 70%";
		return { size, sepX, sepY, scrollEndValue, scrollStartValueStage1, scrollStartValueSlogan };
	}
  
	function getCoFullWidth() {
		const clone = document.querySelector(".co-clone");
		console.log("Clone width:", clone.offsetWidth);
		return clone.offsetWidth;
	}
  
	// Main builder
	function buildTriggers() {
	
		//Slogan
		// const coWidth = getCoFullWidth() + 1;
		//Circles
		const { size, sepX, sepY, scrollEndValue, scrollStartValueStage1, scrollStartValueSlogan } = getMetrics();
		//Initial settings
		// gsap.set(".co", {width: 0, opacity: 0, x: "-0.5em"});
		// Reset all animated properties
		gsap.set([".circle-1", ".circle-2", ".circle-3"], { 
		width: size, height:size, xPercent: -50, yPercent: -50, x: 0, y: 0, scale: 1, autoAlpha: 0 
		});
		gsap.set([".stageText", ".descText"], { opacity: 0 })
		gsap.set(["#stageTextContainer", "#descTextContainer"], { opacity: 0, y:600 });
		gsap.set("#circleContainer", { opacity: 0 });
	
		// slogan = gsap.timeline({ paused: true });
		// ScrollTrigger.create({
		// 	trigger: ".sloganWords",
		// 	start: scrollStartValueSlogan,
		// 	scrub: false,
		// 	toggleActions: "play none none reverse",
		// 	animation: slogan,
		// 	onEnter: () => {
		// 		console.log("Slogan triggered");
		// 	},
		// 	markers: true,
		// });
	
		// slogan.to(".co", {width: coWidth, opacity: 1, x: 0, duration: 0.5, ease: "power2.out"});
	
		// Stage 1
		stage1 = gsap.timeline({ paused: true });

		ScrollTrigger.create({
			id: "circle-stage-1",
			trigger: ".stage-1",
			start: scrollStartValueStage1,
			// end: "bottom bottom",
			// end: `+=${scrollDuration}`, // ensures at least 1000px of scroll space
			end: scrollEndValue,
			scrub: false,
			pin: true,
			pinSpacing: true,
			toggleActions: "play none none reverse",
			animation: stage1,
			onEnter: () => {
				console.log("Stage 1 triggered");
			},
			// markers:true
		});
	
		stage1.set(".circle-3", { autoAlpha: 0 })
			.to(".circle-1", { x: -sepX, y: 0, autoAlpha: 1, duration: 1.2 })
			.to(".circle-2", { x:  sepX, y: 0, autoAlpha: 1, duration: 1.2 }, "<")
			.to("#circleContainer", { autoAlpha: 1, y:0 }, 0)
			.to("#stageTextContainer", { autoAlpha: 1, y:0 }, 0)
			.to(".stageText", { x: -80, autoAlpha: 0, duration: 0.1 }, 0)
			.to(".stage-text-1", { x: 0, autoAlpha: 1, duration: 0.3 }, 0)
			.to("#descTextContainer", { autoAlpha: 1, y:0 }, 0)
			.to(".descText", { x: -30, autoAlpha: 0, duration: 0.1 }, 0)
			.to(".desc-text-1", { x: 0, autoAlpha: 1, duration: 0.3 }, 0)
			.to("#introTextContainer", { autoAlpha: 0 }, 0);
	
		// Stage 2
		stage2 = gsap.timeline({ paused: true });
		ScrollTrigger.create({
			id: "circle-stage-2",
			trigger: ".stage-2",
			start: "top 30%",
			// end: "bottom bottom",
			// end: `+=${scrollDuration}`, // ensures at least 1000px of scroll space
			end: scrollEndValue,
			scrub: 0.3,
			pin: true,
			pinSpacing: true,
			toggleActions: "play none none reverse",
			animation: stage2,
			onEnter: () => {
				console.log("Stage 2 triggered");
			},
			// markers:true
		});
	
		stage2.to(".circle-3", { autoAlpha: 1, duration: 0.1 }, 0)
			.to(".circle-1", { x: -sepX, y:  sepY, duration: 0.3 }, 0)
			.to(".circle-2", { x:  sepX, y:  sepY, duration: 0.3 }, 0)
			.to(".circle-3", { x:    0, y: -sepY, duration: 0.3 }, 0)
			.to(".stageText", { x: -80, autoAlpha: 0, duration: 0.1 }, 0)
			.to(".stage-text-2", { x: 0, autoAlpha: 1, duration: 0.3 }, 0)
			.to("#descTextContainer", { autoAlpha: 1 }, 0)
			.to(".descText", { x: -30, autoAlpha: 0, duration: 0.1 }, 0)
			.to(".desc-text-2", { x: 0, autoAlpha: 1, duration: 0.3 }, 0);
	
		// Stage 3
		const expandedSize = getComputedStyle(document.documentElement)
							.getPropertyValue('--circle-expanded')
							.trim();
	
		stage3 = gsap.timeline({ paused: true });
		ScrollTrigger.create({
			id: "circle-stage-3",
			trigger: ".stage-3",
			start: "top 30%",
			// end: "bottom bottom",
			// end: `+=${scrollDuration}`, // ensures at least 1000px of scroll space
			end: scrollEndValue,
			scrub: 0.3,
			pin: true,
			pinSpacing: true,
			toggleActions: "play none none reverse",
			animation: stage3,
			onEnter: () => {
				console.log("Stage 3 triggered");
			},
			// markers:true
		});
	
		stage3.to([".circle-1", ".circle-2", ".circle-3"], {
		top: "50%",
		left: "50%",
		xPercent: -50,
		yPercent: -50,
		x: 0,
		y: 0,
		width: expandedSize,
		height: expandedSize,
		borderWidth: "1px",
		ease: "power1.inOut",
		autoAlpha: 1,
		duration: 0.6
		}, 0)
		.to(".stageText", { x: -80, autoAlpha: 0, duration: 0.1 }, 0)
		.to(".stage-text-3", { x: 0, autoAlpha: 1, duration: 0.3 }, 0)
		.to("#descTextContainer", { autoAlpha: 1 }, 0)
		.to(".descText", { x: -30, autoAlpha: 0, duration: 0.1 }, 0)
		.to(".desc-text-3", { x: 0, autoAlpha: 1, duration: 0.3 }, 0);
	
		stageEnd = gsap.timeline({ paused: true });
		ScrollTrigger.create({
			id: "stage-end",
			trigger: ".stageEnd",
			start: "top 70%",
			end: "bottom bottom",
			scrub: 0.3,
			toggleActions: "play none none reverse",
			animation: stageEnd,
			onEnter: () => {
				console.log("Stage End triggered");
			},
			// markers:true
		});
	
		stageEnd.to([".circle-1", ".circle-2", ".circle-3"], { autoAlpha: 0 }, 0)
				.to("#stageTextContainer", { autoAlpha: 0, y:-400 }, 0)
				.to(".stageText", { autoAlpha: 0 }, 0)
				.to("#descTextContainer", { autoAlpha: 0, y:-400 }, 0)
				.to(".descText", { autoAlpha: 0 }, 0);
	
		ScrollTrigger.refresh();
	}
  
	// Full reset: kill triggers & rebuild
	function rebuildAll() {
		ScrollTrigger.getAll().forEach(st => st.kill());
		window.scrollTo(0, 0);
		buildTriggers();
	}

	mm.add("(max-width: 576px)", () => rebuildAll());
	mm.add("(min-width: 577px) and (max-width: 992px)", () => rebuildAll());
	mm.add("(min-width: 993px)", () => rebuildAll());

	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
		});
	});

}